/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gallery_Category_Poster_DesignInputs */

const en_gallery_category_poster_design = /** @type {(inputs: Gallery_Category_Poster_DesignInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poster Design`)
};

const es_gallery_category_poster_design = /** @type {(inputs: Gallery_Category_Poster_DesignInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diseno de posters`)
};

/**
* | output |
* | --- |
* | "Poster Design" |
*
* @param {Gallery_Category_Poster_DesignInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const gallery_category_poster_design = /** @type {((inputs?: Gallery_Category_Poster_DesignInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gallery_Category_Poster_DesignInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gallery_category_poster_design(inputs)
	return es_gallery_category_poster_design(inputs)
});